import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React ErrorBoundary caught an error:', error, error?.stack, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white font-mulish">
          <div className="flex items-center justify-center min-h-screen p-6">
            <div className="max-w-md w-full bg-white border border-red-200 rounded-[3px] shadow-sm p-6 text-center">
              <h1 className="text-2xl font-bold text-gray-900 mb-4 font-cabin">Something went wrong</h1>
              <p className="text-gray-600 font-mulish mb-4">
                We encountered an unexpected error while loading this page. Please refresh the page or try again later.
              </p>
              <p className="text-sm text-gray-500 font-mulish">
                If the issue persists, contact support@ubiewebsites.co.uk with a description of what you were doing.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
